import { Breadcrumb, Button, Col, Layout, Menu, Row } from "antd";
import {
  AccountIcon,
  AuctionIcon,
  BillIcon,
  ExitIcon,
  HomeIcon,
  ManagmentIcon,
  PurchaseIcon,
  ReceivecashIcon,
  WalletIcon,
} from "../../assets/fonts/icon/icons";
import "./layouts.scss";
import ADS from "../../components/ads/Ads";
import { useDispatch, useSelector } from "react-redux";
import { complexDigitToman, isEmptyObject } from "../../tools/tools";
import { CheckToken, clearApp } from "../../tools/services";
import { _adr } from "../../address";
import { useLocation, useNavigate } from "react-router-dom";
import { createContext, useContext, useEffect, useState } from "react";
import { useAPIPublic } from "../../tools/api";
import { globalValue } from "../../reducer/serviceReducerGlobala";
import { HomeOutlined } from "@ant-design/icons";
import HasUser from "./hasUser/hasUser";

import MenuBar, { MenuGlobal } from "./menu/MenuBar";
import MobileView from "./mobile/mobile";

const LayoutsContext = createContext();
export const useLayouts = () => {
  return useContext(LayoutsContext);
};

export const Layouts = ({ children }) => {
  //#region Control
  const nav = useNavigate();
  const location = useLocation();
  const { queryCurrentUser } = useAPIPublic();
  const dispatch = useDispatch();
  const [reloadWallet, setReloadWallet] = useState(false);
  const { Sider } = Layout;
  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const [showLayout, setShowLayout] = useState(true);

  const checkLoginUser = async () => {
    const isToken = await CheckToken();
    if (isToken && !isEmptyObject(_currentUser)) {
      return true;
    } else {
      return false;
    }
  };

  const refreshUser = async (isQuery = false) => {
    if (isQuery) {
      const resUser = await queryCurrentUser();
      if (resUser && !resUser?.HasError) {
        dispatch(globalValue({ _currentUser: { ...resUser.Result } }));
      }
      return resUser.Result;
    } else {
      return _currentUser;
    }
  };

  const changeLayout = (state) => {
    setShowLayout(state);
  };

  const handleExit = async () => {
    await clearApp();
    window.location.href = _adr.Root + _adr.Landing.Index;
  };
  const handleReloadProfile = async () => {};
  const landingPath = _adr.Root + _adr.Landing.Index;
  const isSearchPage = location.pathname === landingPath + _adr.Landing.Search;
  const breadcrumbItems = [
    {
      title: (
        <button type="button" className="breadcrumb-link" aria-label="صفحه اصلی مزایده" onClick={() => nav(landingPath)}>
          <HomeOutlined />
        </button>
      ),
    },
    {
      title: isSearchPage ? (
        <button type="button" className="breadcrumb-link" onClick={() => nav(landingPath)}>
          مزایده سیم‌کارت‌های رند
        </button>
      ) : (
        "مزایده سیم‌کارت‌های رند"
      ),
    },
    ...(isSearchPage ? [{ title: "جستجوی سیم‌کارت" }] : []),
  ];

  useEffect(() => {
    // handleReloadProfile();
  }, []);
  //#endregion Control
  return (
    <>
      <LayoutsContext.Provider value={{ refreshUser, checkLoginUser, changeLayout, handleExit }}>
        {showLayout ? (
          <>
            <MobileView />
            <Row justify={"center"}>
              <Col span={24}>
                <div className="holder-bread-crumbs">
                  <Row justify={"center"}>
                    <Col xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
                      <Breadcrumb
                        separator=">"
                        items={breadcrumbItems}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
                <Layout className="main_layout">
                  <Sider className="sidebar">
                    <HasUser userInfo={_currentUser} />
                    <div className="holder-show-ads">
                      <ADS />
                    </div>
                  </Sider>
                  <Layout className="body_layout">{children}</Layout>
                </Layout>
              </Col>
            </Row>
          </>
        ) : (
          <>{children}</>
        )}
      </LayoutsContext.Provider>
    </>
  );
};

export default Layouts;
